<div class="preview_wrapper">
  <p class="title">Bid Details
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Bid Name</p>
        <p class="value">{{bidDetail?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Building Specifications</p>
        <p class="value">{{bidDetail?.building_specifications}}</p>
      </div>
    </div>
    @if (!isEdit) {
      <div class="col-md-6">
        <div class="wrap">
          <p class="heading">Customer</p>
          <p class="value">{{bidDetail?.customer?.customer_id?.name}}</p>
        </div>
      </div>
    }
    @if (!isEdit) {
      <div class="col-md-6">
        <div class="wrap">
          <p class="heading">Contact</p>
          <p class="value">{{bidDetail?.customer?.contact_id?.name}}</p>
        </div>
      </div>
    }
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Bid Due Date</p>
        <p class="value">{{bidDetail?.due_date_at | date}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Bid Due Time</p>
        <p class="value">{{bidDetail?.startTime | date:'h:mm a'}}</p>
      </div>
    </div>
  </div>
</div>

<div class="preview_wrapper">
  <p class="title">Scopes
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Scopes</p>
        <p class="value">{{coreService.arrayObjectToString(scopesStage?.scopes)}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Sales Stage</p>
        <p class="value">{{scopesStage?.stage_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Bid Type</p>
        <p class="value">{{coreService.arrayObjectToString(scopesStage?.bid_types)}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Source</p>
        <p class="value">{{scopesStage?.source_id?.name}}</p>
      </div>
    </div>

    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Probability</p>
        <p class="value">{{scopesStage?.probability| number : '1.2-2'}}%</p>
      </div>
    </div>

    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Description</p>
        <p class="value">{{scopesStage?.description}}</p>
      </div>
    </div>

  </div>
</div>


<div class="preview_wrapper">
  <p class="title">Assignment
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Project Manager</p>
        <p class="value">{{assignment?.project_manager_id?.full_name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Assign To</p>
        <p class="value">{{assignment?.assigned_to_id?.full_name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Estimator</p>
        <p class="value">{{assignment?.estimator_id?.full_name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Sales Rep</p>
        <p class="value">{{assignment?.sales_rep_id?.full_name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Secondary Sales Rep</p>
        <p class="value">{{assignment?.secondary_sales_rep_id?.full_name}}</p>
      </div>
    </div>

  </div>
</div>

<div class="preview_wrapper">

  <p class="title">Jobsite Address


    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Job Site </p>
        <p class="value">{{jobsiteAddressDetail?.jobsite_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 1</p>
        <p class="value">{{jobsiteAddressDetail?.jobsiteAddress?.address_line_1}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 2</p>
        <p class="value">{{jobsiteAddressDetail?.jobsiteAddress?.address_line_2}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">City</p>
        <p class="value">{{jobsiteAddressDetail?.jobsiteAddress?.city}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">State</p>
        <p class="value">{{jobsiteAddressDetail?.jobsiteAddress?.state_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Zip code</p>
        <p class="value">{{jobsiteAddressDetail?.jobsiteAddress?.zipcode}}</p>
      </div>
    </div>
  </div>
</div>
